import axios from "axios";

const appEnv = process.env.REACT_APP_ENV;
const isProd = appEnv
    ? appEnv === "production"
    : process.env.NODE_ENV === "production";

const baseURL: string | boolean | undefined = isProd
    ? process.env.REACT_APP_MANTLE_PROD_API_BASE_URL
    : process.env.REACT_APP_MANTLE_DEV_API_BASE_URL;

const headers: any = {};

const axiosDataFetcher = axios.create({
    baseURL,
    headers,
});

axiosDataFetcher.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response) {
            return error.response;
        }
    }
);

export default axiosDataFetcher;
